import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import merge from 'lodash/merge'
import { withRouter } from 'react-router-dom'
import { editPartnerPlan } from 'actions/partnerPlanForm'
import { setSelectedPlan } from 'actions/partnerPlans'
import { getPartnerPlanDocuments } from 'actions/partnerPlan'
import DraftPlanDisplayForm from 'views/PartnerPlans/DraftPlanDisplayForm'
import SubmittedPlanDisplayForm from 'views/PartnerPlans/SubmittedPlanDisplayForm'
import InterimPlanDisplayForm from 'views/PartnerPlans/InterimPlanDisplayForm'
import InterimCounsellorPlanDisplayForm from 'views/PartnerPlans/InterimCounsellorPlanDisplayForm'
import FinalPlanDisplayForm from 'views/PartnerPlans/FinalPlanDisplayForm'
import FinalCounsellorPlanDisplayForm from 'views/PartnerPlans/FinalCounsellorPlanDisplayForm'
import constants from 'constants'
import { commonFunctions } from 'utils/CommonFunctions'

class PartnerPlanForm extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    partnerPlan: PropTypes.object.isRequired,
    partnerPlanForm: PropTypes.object.isRequired,
    selectedPartner: PropTypes.object.isRequired,
    selectedPlan: PropTypes.object.isRequired,
  }

  static defaultProps = {
    id: '',
  }

  _submit = (data) => {
    const {
      id, partnerPlan, selectedPlan, currentUser,
    } = this.props

    const formData = {
      employee_id: selectedPlan.EmployeeId,
      loginname: '', // loginname is stored on the webapi server session
      year: partnerPlan.partnerPlan.year,
      interimCounsellee: (partnerPlan.partnerPlan.interimCounsellee ? partnerPlan.partnerPlan.interimCounsellee : ''),
      interimCounselleeComments: (partnerPlan.partnerPlan.interimCounselleeComments ? partnerPlan.partnerPlan.interimCounselleeComments : ''),
      interimCounsellor: (partnerPlan.partnerPlan.interimCounsellor ? partnerPlan.partnerPlan.interimCounsellor : ''),
      interimCounsellorComments: (partnerPlan.partnerPlan.interimCounsellorComments ? partnerPlan.partnerPlan.interimCounsellorComments : ''),
      interimAgreedDate: (partnerPlan.partnerPlan.interimAgreedDate ? partnerPlan.partnerPlan.interimAgreedDate : ''),
      finalCounselleeAssessment: (partnerPlan.partnerPlan.finalCounselleeAssessment ? partnerPlan.partnerPlan.finalCounselleeAssessment : ''),
      finalCounselleeComments: (partnerPlan.partnerPlan.finalCounselleeComments ? partnerPlan.partnerPlan.finalCounselleeComments : ''),
      finalCounsellorAssessment: (partnerPlan.partnerPlan.finalCounsellorAssessment ? partnerPlan.partnerPlan.finalCounsellorAssessment : ''),
      finalCounsellorComments: (partnerPlan.partnerPlan.finalCounsellorComments ? partnerPlan.partnerPlan.finalCounsellorComments : ''),
      finalAgreedDate: (partnerPlan.partnerPlan.finalAgreedDate ? partnerPlan.partnerPlan.finalAgreedDate : ''),
      planStatus: (partnerPlan.partnerPlan.planStatus ? partnerPlan.partnerPlan.planStatus : ''),
      /* lastModifiedBy: (currentUser.IsAdmin ? constants.PARTNERPLAN.MODIFIED_BY_ADMIN : commonFunctions.iff(
        (currentUser.GivenName && currentUser.Surname),
        `${currentUser.GivenName} ${currentUser.Surname}`, currentUser.DisplayName,
      )), */
      lastModifiedBy: (commonFunctions.isAdminPortal() ? constants.PARTNERPLAN.MODIFIED_BY_ADMIN : commonFunctions.iff(
        (this.props.currentUser.GivenName && this.props.currentUser.Surname),
        `${this.props.currentUser.GivenName} ${this.props.currentUser.Surname}`, this.props.currentUser.DisplayName,
      )),
      planAgreedDate: (partnerPlan.partnerPlan.planAgreedDate ? partnerPlan.partnerPlan.planAgreedDate : ''),
      planSubmittedDate: (partnerPlan.partnerPlan.planSubmittedDate ? partnerPlan.partnerPlan.planSubmittedDate : ''),
      planUploadedDate: (partnerPlan.partnerPlan.planUploadedDate ? partnerPlan.partnerPlan.planUploadedDate : ''),
      interimDate: (partnerPlan.partnerPlan.interimDate ? partnerPlan.partnerPlan.interimDate : ''),
      finalDate: (partnerPlan.partnerPlan.finalDate ? partnerPlan.partnerPlan.finalDate : ''),
      planAgreedWithCounsellee: (partnerPlan.partnerPlan.planAgreedWithCounsellee ? partnerPlan.partnerPlan.planAgreedWithCounsellee : ''),
      interimPlanAgreedWithCounsellee: (partnerPlan.partnerPlan.interimPlanAgreedWithCounsellee ? partnerPlan.partnerPlan.interimPlanAgreedWithCounsellee : ''),
      finalPlanAgreedWithCounsellee: (partnerPlan.partnerPlan.finalPlanAgreedWithCounsellee ? partnerPlan.partnerPlan.finalPlanAgreedWithCounsellee : ''),
      // notification requirement
      cpEmail: (selectedPlan.CPEmail ? selectedPlan.CPEmail : ''),
      mlEmail: (selectedPlan.MLEmail ? selectedPlan.MLEmail : ''),
      blEmail: (selectedPlan.BLEmail ? selectedPlan.BLEmail : ''),
      cilEmail: (selectedPlan.CILEmail ? selectedPlan.CILEmail : ''),
      bucooEmail: (selectedPlan.BUCOOEmail ? selectedPlan.BUCOOEmail : ''),
      olEmail: (selectedPlan.OLEmail ? selectedPlan.OLEmail : ''),
      oplEmail: (selectedPlan.OPLEmail ? selectedPlan.OPLEmail : ''),
      adminComments: (selectedPlan.AdminComments ? selectedPlan.AdminComments : ''),
    }

    if (String(id) === constants.PARTNERPLAN.FORMS.DRAFT) {
      formData.planUploadedDate = (data.planUploadedDate ? data.planUploadedDate : '')
      switch (partnerPlan.partnerPlan.planStatus) {
        case constants.PARTNERPLAN.STATUS.DRAFT:
        case constants.PARTNERPLAN.STATUS.UPLOADED:
          formData.planStatus = constants.PARTNERPLAN.STATUS.UPLOADED
          break
        case constants.PARTNERPLAN.STATUS.SUBMITTED:
          formData.planStatus = constants.PARTNERPLAN.STATUS.SUBMITTED
          break
        default:
      }
      // formData.planstatus = constants.PARTNERPLAN.STATUS.UPLOADED
    }
    if (String(id) === constants.PARTNERPLAN.FORMS.SUBMITTED) {
      formData.planAgreedWithCounsellee = (data.planAgreedWithCounsellee ? data.planAgreedWithCounsellee : '')
      formData.planAgreedDate = (data.planAgreedDate ? data.planAgreedDate : '')
      formData.planStatus = constants.PARTNERPLAN.STATUS.AGREED
    }
    if (String(id) === constants.PARTNERPLAN.FORMS.INTERIM) {
      formData.interimCounsellee = (data.interimCounsellee ? data.interimCounsellee : '')
      formData.interimCounselleeComments = (data.interimCounselleeComments ? data.interimCounselleeComments : '')
      formData.interimDate = (data.interimDate ? data.interimDate : '')
      // status remains the same no change
      // formData.planStatus = constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED
    }
    if (String(id) === constants.PARTNERPLAN.FORMS.INTERIM_COUNSELLOR) {
      formData.interimPlanAgreedWithCounsellee = (data.interimPlanAgreedWithCounsellee ? data.interimPlanAgreedWithCounsellee : '')
      formData.interimCounsellor = (data.interimCounsellor ? data.interimCounsellor : '')
      formData.interimCounsellorComments = (data.interimCounsellorComments ? data.interimCounsellorComments.trim() : '')
      formData.interimAgreedDate = (data.interimAgreedDate ? data.interimAgreedDate : '')
      formData.planStatus = constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED
    }
    if (String(id) === constants.PARTNERPLAN.FORMS.FINAL) {
      formData.finalCounselleeAssessment = (data.finalCounselleeAssessment ? data.finalCounselleeAssessment : '')
      formData.finalCounselleeComments = (data.finalCounselleeComments ? data.finalCounselleeComments : '')
      formData.finalDate = (data.finalDate ? data.finalDate : '')
      // status remains the same no change
      // formData.planStatus = constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED
    }
    if (String(id) === constants.PARTNERPLAN.FORMS.FINAL_COUNSELLOR) {
      formData.finalPlanAgreedWithCounsellee = (data.finalPlanAgreedWithCounsellee ? data.finalPlanAgreedWithCounsellee : '')
      formData.finalCounsellorAssessment = (data.finalCounsellorAssessment ? data.finalCounsellorAssessment : '')
      formData.finalCounsellorComments = (data.finalCounsellorComments ? data.finalCounsellorComments.trim() : '')
      formData.finalAgreedDate = (data.finalAgreedDate ? data.finalAgreedDate : '')
      formData.planStatus = constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED
    }

    if (formData.employee_id && formData.year && formData.planStatus) {
      formData.loggedin_employee_id = currentUser.EmployeeId
      this.props.dispatch(editPartnerPlan(formData, id, selectedPlan.Role))
    }
  }

  render() {
    const {
      modals, hide, forms, id, partnerPlan, partnerPlanForm, selectedPartner, selectedPlan, currentUser,
    } = this.props
    
    if (partnerPlan.partnerPlan.planStatus) {
      if (partnerPlan.partnerPlan.planStatus !== selectedPlan.PlanStatus) {
        // update selected plan status and reload documents
        // this.props.history.goBack()
        const updatedPlan = merge({}, selectedPlan, {
          PlanStatus: partnerPlan.partnerPlan.planStatus,
        })
        this.props.dispatch(setSelectedPlan(updatedPlan))
        this.props.dispatch(getPartnerPlanDocuments(
          this.props.selectedPlan.EmployeeId,
          this.props.selectedPlan.PlanYear,
          partnerPlan.partnerPlan.planStatus,
          this.props.selectedPlan.Role,
        ))
      }
    }

    if (id) {
      if (String(id) === constants.PARTNERPLAN.FORMS.DRAFT) {
        return (
          <DraftPlanDisplayForm
            currentUser={currentUser}
            description="Ensure your file meets the criteria specified in the partner plan template."
            dispatch={this.props.dispatch}
            forms={forms}
            handleSubmit={this._submit}
            hide={hide}
            id={id}
            modals={modals}
            partnerPlan={partnerPlan}
            partnerPlanForm={partnerPlanForm}
            selectedPartner={selectedPartner}
            selectedPlan={selectedPlan}
            title={`${String(selectedPlan.PlanStatus) === constants.PARTNERPLAN.STATUS.DRAFT ? 'Upload ' : 'Replace '} Partner plan`}
          />
        )
      }
      if (String(id) === constants.PARTNERPLAN.FORMS.SUBMITTED) {
        return (
          <SubmittedPlanDisplayForm
            currentUser={currentUser}
            description=""
            dispatch={this.props.dispatch}
            forms={forms}
            handleSubmit={this._submit}
            hide={hide}
            id={id}
            modals={modals}
            partnerPlan={partnerPlan}
            partnerPlanForm={partnerPlanForm}
            selectedPartner={selectedPartner}
            selectedPlan={selectedPlan}
            title="Agree Partner plan"
          />
        )
      }      
      if (String(id) === constants.PARTNERPLAN.FORMS.INTERIM) {
        return (
          <InterimPlanDisplayForm
            currentUser={currentUser}
            description=""
            dispatch={this.props.dispatch}
            forms={forms}
            handleSubmit={this._submit}
            hide={hide}
            id={id}
            modals={modals}
            partnerPlan={partnerPlan}
            partnerPlanForm={partnerPlanForm}
            selectedPartner={selectedPartner}
            selectedPlan={selectedPlan}
            title="Interim supporting documents"
          />
        )
      }
      if (String(id) === constants.PARTNERPLAN.FORMS.INTERIM_COUNSELLOR) {
        return (
          <InterimCounsellorPlanDisplayForm
            currentUser={currentUser}
            description=""
            dispatch={this.props.dispatch}
            forms={forms}
            handleSubmit={this._submit}
            hide={hide}
            id={id}
            modals={modals}
            partnerPlan={partnerPlan}
            partnerPlanForm={partnerPlanForm}
            selectedPartner={selectedPartner}
            selectedPlan={selectedPlan}
            title={constants.PARTNERPLAN.RATINGSFORMHEADER.COACH_INTERIM}
          />
        )
      }
      if (String(id) === constants.PARTNERPLAN.FORMS.FINAL) {
        return (
          <FinalPlanDisplayForm
            currentUser={currentUser}
            description=""
            dispatch={this.props.dispatch}
            forms={forms}
            handleSubmit={this._submit}
            hide={hide}
            id={id}
            modals={modals}
            partnerPlan={partnerPlan}
            partnerPlanForm={partnerPlanForm}
            selectedPartner={selectedPartner}
            selectedPlan={selectedPlan}
            title="Final supporting documents"
          />
        )
      }
      if (String(id) === constants.PARTNERPLAN.FORMS.FINAL_COUNSELLOR) {
        return (
          <FinalCounsellorPlanDisplayForm
            currentUser={currentUser}
            description=""
            dispatch={this.props.dispatch}
            forms={forms}
            handleSubmit={this._submit}
            hide={hide}
            id={id}
            modals={modals}
            partnerPlan={partnerPlan}
            partnerPlanForm={partnerPlanForm}
            selectedPartner={selectedPartner}
            selectedPlan={selectedPlan}
            title={constants.PARTNERPLAN.RATINGSFORMHEADER.COACH_FINAL}
          />
        )
      }
    }
    return (<div />)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  modals: state.modals,
  forms: state.forms,
  partnerPlan: state.partnerPlan,
  partnerPlanForm: state.partnerPlanForm,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
  selectedPlan: (Object.keys(state.partnerPlans.selectedPlan).length === 0 && sessionStorage.getItem('SelectedPlan') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPlan')) :
    state.partnerPlans.selectedPlan),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PartnerPlanForm))



// WEBPACK FOOTER //
// ./src/containers/PartnerPlanForm.js